import React from 'react';
import styled from '@emotion/native';
import EmailLink from './EmailLink';
import { BodyText } from '@/shared/components/StyledText';
import { green } from '@/shared/styles/colors';
import { StyleProp, TextStyle } from 'react-native';

interface Props {
  style?: StyleProp<TextStyle>;
}

const MissingStyleSupportText = ({ style }: Props) => {
  return (
    <SupportText style={style}>
      Don&apos;t see your style type?{' '}
      <EmailLink
        style={{
          fontSize: 16,
          textDecorationLine: 'underline',
          fontWeight: 'bold',
        }}
      >
        Let us know here
      </EmailLink>
    </SupportText>
  );
};

const SupportText = styled(BodyText)(() => ({
  fontSize: 16,
  lineHeight: 18,
  color: green,
  textAlign: 'right',
  marginBottom: 20,
}));

export default MissingStyleSupportText;
